import { constructorInstance } from './constructor-instance';
import { constructorToBrand } from './util';

export async function getBrandsFromDealIds(ids: string[], defaultFilters: any = {}, constructor: any = constructorInstance) {
    const result = await constructor.browse.getBrowseResults('group_id', 'customerCategories', {
        filters: {
            ...defaultFilters?.filters || {},
            AffiliateBrandId: ids,
        },
    });

    return constructorToBrand(result.response?.results);
}
